<!--
 * @Description: 首页·mobile 第4个模块 宝贝收获 & 合作伙伴
 * @Author: xiehuaqiang
 * @FilePath: /kada-official-web/public/mobile/src/views/home/CollectAndPartner.vue
 * @Date: 2020-12-18 13:29:59
-->
<template>
    <div class='module-cont module-harvest'>
        <div class="section-partner">
            <div class="title-cont">
                <h1><span class="fzlty-zc">KaDa</span>阅读渠道合作方</h1>
            </div>
            <div class="parttner-channel-list" >
                <div
                    :class="{'parttner-channel-item':true,'not-first-item': index%4 !== 0 }"
                    v-for="(item,index) in channelList"
                    :key="index">
                    <img :src="item" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components:{},
        data() {
            return {
                channelList:[
                    'https://cdn.hhdd.com/frontend/as/i/16798cb4-d547-5395-9a5d-2cbffbd34f0e.png', // 天猫
                    'https://cdn.hhdd.com/frontend/as/i/ecd6868f-f8ad-584d-a726-db39bc7fc91f.png', // 百度
                    'https://cdn.hhdd.com/frontend/as/i/15fd2299-fa34-525b-aecd-6a63c75357c5.png', // jd
                    'https://cdn.hhdd.com/frontend/as/i/412caca0-7d4f-56ac-878e-25674d5a8a0f.png', // qtFM
                    'https://cdn.hhdd.com/frontend/as/i/4528a8a2-3401-5144-bf6c-7bf0a8328e1e.png', // 步步高
                    'https://cdn.hhdd.com/frontend/as/i/18d6e04b-2e74-5b14-862f-78c63550025c.png', // 优学派
                    'https://cdn.hhdd.com/frontend/as/i/92d020fe-ef09-5293-a4c3-1474d76dc8f0.png', // roobo
                    'https://cdn.hhdd.com/frontend/as/i/de189c3b-4d5d-5979-b12f-1fd113f17853.png', // keeko
                    'https://cdn.hhdd.com/frontend/as/i/96e56114-f151-598e-af35-3282a33c2c99.png', // 小天才
                    'https://cdn.hhdd.com/frontend/as/i/3abc1b6d-0771-53e8-9b95-7b7d0ddc0fe8.png', // 科大讯飞
                    'https://cdn.hhdd.com/frontend/as/i/9033aeef-ea2b-5c4b-82b6-d5aea260d33c.png', // 华为
                    'https://cdn.hhdd.com/frontend/as/i/56835d0e-7c8a-563f-b463-4fa509762983.png', // 读书郎
                ]
            }
        },
    }
</script>

<style lang='stylus' scoped>
@import "../../style/vui/mixins"
.module-harvest
    .title-cont
        padding-top px2rem2(39)
        text-align center
        h1
            font-size px2rem2(20)
            font-weight 600
            color #3F3F3F
            height px2rem2(28)
            line-height px2rem2(28)
            margin-bottom px2rem2(6)
        p
            font-size px2rem2(12)
            color #666666
            height px2rem2(17)
            line-height px2rem2(17)
    .img-cont
        padding px2rem2(30) px2rem2(20) px2rem2(0)
        img
            margin-bottom px2rem2(20)
            &:last-child
                margin-bottom px2rem2(0)
    .parttner-channel-list
        display flex
        flex-wrap wrap
        justify-content space-between
        margin-top px2rem2(20)
        .parttner-channel-item
            margin-bottom px2rem2(10)
            img
                width px2rem2(77)
                height px2rem2(77)
        .not-first-item
            // margin-left px2rem2(10)
    .section-harvest
        background #F2F9FF
        padding-bottom px2rem2(40)
    .section-partner
        // background #fff
        padding 0 px2rem2(16)
        .title-cont
            padding-top px2rem2(30)
       
</style>



// WEBPACK FOOTER //
// src/views/home/CollectAndPartner.vue